import React from "react";
interface StatusBadgeProps {
  status: "active" | "pending" | "expired" | "compliant" | "review";
  children: React.ReactNode;
}
export function StatusBadge({ status, children }: StatusBadgeProps) {
  const variants = {
    active: "bg-emerald-100 text-emerald-700 border-emerald-200",
    pending: "bg-amber-100 text-amber-700 border-amber-200",
    expired: "bg-red-100 text-red-700 border-red-200",
    compliant: "bg-blue-100 text-blue-700 border-blue-200",
    review: "bg-purple-100 text-purple-700 border-purple-200",
  };
  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${variants[status]}`}
      role="status"
      aria-label={`Status: ${children}`}
    >
      {children}
    </span>
  );
}
